import React, { useState } from "react";
import Replicate_Testing_Form from "./replicate_Testing_Form/Replicate_Testing_Form";
import Replicate_Testing_table from "./replicate_Testing_table/Replicate_Testing_table";

function Replicate_Testing() {
  const [showTable, setShowTable] = useState(false);

  return (
    <>
      <div className="imperiality_Form_div">
        <Replicate_Testing_Form onProceed={() => setShowTable(true)} />
      </div>

      {showTable && (
        <div className="imperiality_table_div">
          <Replicate_Testing_table/>
        </div>
      )}
    </>
  );
}

export default Replicate_Testing;
